module.exports = __webpack_public_path__ + "h5/img/detail-opt2.ea8b607b.png";